import React, { useEffect, useState } from "react";
import {
	Blacked,
	BoardViewInput,
	CommentWrapper,
	DBModalInputLine,
	DBModalMemoArea,
	MemoSubmitBtn,
	ModalContent,
	ModalHeader,
	ModalInput,
	ModalSubmit,
	ModalTitle,
	ModalWrapper,
} from "./styles";
import { Icon } from "CRM/organism/Main/styles";
import { FaChevronLeft, FaPen, FaTrash } from "react-icons/fa6";
import { Button, Input, Select, Table, message, Upload } from "antd";
import { ChromePicker } from "react-color";
import API from "utils/api";
import { useToken } from "app/hooks";
import { usePathList } from "CRM/hooks/GetPathList";
import TextArea from "antd/es/input/TextArea";
import { useCategoryList } from "CRM/hooks/GetCategory";
import { usePlatformList } from "CRM/hooks/GetPlatformList";
import { useBoardContent } from "CRM/hooks/GetBoardContent";
import { useBoardComment } from "CRM/hooks/GetBoardComment";
import { API_URL } from "../../app/constants/APIKEYS";
import { ImageModal } from "./Edit/ImageModal";
import { useIsMobile } from "./IsMobile";

export const BoardView = ({ setIsSelect, boardId, getBoadListMutate }) => {
	const IsMobile = useIsMobile();
	const { data: token } = useToken();
	const { boardContent } = useBoardContent(boardId);
	const { boardComment, mutate } = useBoardComment(boardId);
	const [answer, setAnswer] = useState("");
	const [editAnswer, setEditAnswer] = useState("");
	const [isHovered, setIsHovered] = useState(false);
	const [isAnswerEdit, setIsAnswerEdit] = useState(false);
	const [changeCheckStatus, setChangeCheckStatus] = useState(false);

	const [imagePath, setImagePath] = useState(null);

	const [status, setStatus] = useState(boardContent?.status);

	const [images, setImages] = useState<any>([]);

	useEffect(() => {
		setStatus(boardContent?.status);
	}, [boardContent]);

	useEffect(() => {
		commentCheck();
	}, []);

	// const ChangeCheckStatus = () => {
	// 	setChangeCheckStatus()
	// }

	const commentCheck = () => {
		API.put("/board/request/" + boardId, token + "", {
			datas: {
				newComment: 0,
			},
		})
			.then((res: any) => {
				if (res.result.success) {
					getBoadListMutate();
				}
			})
			.catch((err: any) => {});
	};

	const addAnswer = () => {
		const shouldEdit = window.confirm(`답변을 등록하시겠습니까?`);
		if (shouldEdit) {
			const targetFilesArrayLogo = Array.from(images?.fileList || []);
			const formData = new FormData();

			if (images?.fileList?.length == 0) {
				message.error("파일을 선택해주세요");
				return;
			}

			targetFilesArrayLogo.forEach((file: any) => {
				if (file.originFileObj) {
					formData.append("files", file.originFileObj);
				}
			});

			formData.append(
				"datas",
				JSON.stringify({
					content: answer,
				})
			);

			if (answer == "") {
				message.error("답변을 입력해주세요.");
			} else {
				API.postImage("POST", "/board/request/" + boardId + "/comment", token + "", formData)
					.then((res: any) => {
						if (res.result.success) {
							message.success("등록되었습니다");
							setAnswer("");
							mutate();
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	const answerDelete = (data) => {
		const shouldEdit = window.confirm(`'${data?.content}' \n 답변을 삭제하시겠습니까?`);
		if (shouldEdit) {
			API.delete("/board/request/" + boardId + "/comment/" + data?.id, token + "", {})
				.then((res: any) => {
					if (res.result.success) {
						message.success("삭제되었습니다");
						mutate();
					}
				})
				.catch((err: any) => {});
		}
	};

	const answerEdit = (data) => {
		const shouldEdit = window.confirm(`답변을 수정하시겠습니까?`);
		if (shouldEdit) {
			API.put("/board/request/" + boardId + "/comment/" + data?.id, token + "", {
				datas: {
					content: editAnswer,
				},
			})
				.then((res: any) => {
					if (res.result.success) {
						message.success("수정되었습니다");
						mutate();
					}
				})
				.catch((err: any) => {});
		}
	};

	const mobileColumns = [
		{
			dataIndex: "",
			title: "코멘트",
			sorter: (a, b) => a.createdAt - b.createdAt,
			render: (value, data) => {
				return (
					<>
						<div style={{ textAlign: "center", display: "flex", padding: 5 }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>날짜: </p>
							{data?.createdAt}
						</div>
						<div style={{ textAlign: "center", display: "flex", padding: 5 }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>작성자: </p>
							{data?.writer}
						</div>
						{!isAnswerEdit ? (
							<div
								onMouseEnter={() => setIsHovered(true)}
								onMouseLeave={() => setIsHovered(false)}
								style={{
									position: "relative",
									display: "block",
									padding: 5,
								}}
							>
								<p style={{ marginRight: 5, fontWeight: "bold" }}>
									답변내용:{" "}
								</p>
								{data?.content}
								<div
									style={{
										display: isHovered ? "flex" : "none",
										position: "relative",
										justifyContent: "flex-end",
										gap: 10,
										width: "100%",
									}}
								>
									<div
										onClick={() => {
											setIsAnswerEdit(true);
											setEditAnswer(data?.content);
										}}
										style={{
											display: "flex",
											alignItems: "center",
											gap: 4,
											color: "#437EFF",
											cursor: "pointer",
										}}
									>
										<Icon>
											<FaPen />
										</Icon>
										수정
									</div>
									<div
										onClick={() => answerDelete(data)}
										style={{
											display: "flex",
											alignItems: "center",
											gap: 4,
											color: "#437EFF",
											cursor: "pointer",
										}}
									>
										<Icon>
											<FaTrash />
										</Icon>
										삭제
									</div>
								</div>
							</div>
						) : (
							<DBModalMemoArea style={{ padding: 10 }}>
								<TextArea
									onChange={(e) => setEditAnswer(e.target.value)}
									placeholder="답변 입력"
									value={editAnswer}
									style={{
										width: "100%",
										height: 50,
										resize: "none",
										fontFamily: "Pretendard",
									}}
								/>
								<MemoSubmitBtn onClick={() => answerEdit(data)}>
									수정
								</MemoSubmitBtn>
								<MemoSubmitBtn
									style={{ backgroundColor: "#dc3545" }}
									onClick={() => setIsAnswerEdit(false)}
								>
									취소
								</MemoSubmitBtn>
							</DBModalMemoArea>
						)}
						<img
							src={data?.image && process.env.REACT_APP_API_URL + data?.image}
							style={{
								width: 80,
								cursor: "pointer",
								marginTop: 20,
								marginLeft: 5,
							}}
							onClick={() => {
								setImagePath(data?.image);
							}}
						/>
					</>
				);
			},
		},
	];

	const columns = [
		{
			dataIndex: "date",
			title: "날짜",
			sorter: (a, b) => a.createdAt - b.createdAt,
			render: (value, data) => {
				return (
					<div style={{ textAlign: "center", width: 300, padding: 5 }}>
						{data?.createdAt}
						<br />
					</div>
				);
			},
		},
		{
			dataIndex: "content",
			title: "답변내용",
			render: (value, data) => {
				return !isAnswerEdit ? (
					<div
						onMouseEnter={() => setIsHovered(true)}
						onMouseLeave={() => setIsHovered(false)}
						style={{
							position: "relative",
							padding: "10px 20px",
							paddingBottom: 25,
							whiteSpace: "pre-wrap",
						}}
					>
						{data?.content}
						<div
							style={{
								display: isHovered ? "flex" : "none",
								position: "absolute",
								bottom: 0,
								right: 20,
								gap: 10,
							}}
						>
							<div
								onClick={() => {
									setIsAnswerEdit(true);
									setEditAnswer(data?.content);
								}}
								style={{
									display: "flex",
									alignItems: "center",
									gap: 4,
									color: "#437EFF",
									cursor: "pointer",
								}}
							>
								<Icon>
									<FaPen />
								</Icon>
								수정
							</div>
							<div
								onClick={() => answerDelete(data)}
								style={{
									display: "flex",
									alignItems: "center",
									gap: 4,
									color: "#437EFF",
									cursor: "pointer",
								}}
							>
								<Icon>
									<FaTrash />
								</Icon>
								삭제
							</div>
						</div>
					</div>
				) : (
					<DBModalMemoArea style={{ padding: 10 }}>
						<TextArea
							onChange={(e) => setEditAnswer(e.target.value)}
							placeholder="답변 입력"
							value={editAnswer}
							style={{
								width: "100%",
								height: 50,
								resize: "none",
								fontFamily: "Pretendard",
							}}
						/>
						<MemoSubmitBtn onClick={() => answerEdit(data)}>수정</MemoSubmitBtn>
						<MemoSubmitBtn
							style={{ backgroundColor: "#dc3545" }}
							onClick={() => setIsAnswerEdit(false)}
						>
							취소
						</MemoSubmitBtn>
					</DBModalMemoArea>
				);
			},
		},
		{
			dataIndex: "writer",
			title: "작성자",
			render: (value, data) => {
				return <div style={{ textAlign: "start", paddingLeft: 18 }}>{value}</div>;
			},
		},
		{
			dataIndex: "image",
			title: "이미지",
			render: (value, data) => {
				return (
					<img
						src={value && process.env.REACT_APP_API_URL + value}
						style={{ width: 80, cursor: "pointer" }}
						onClick={() => {
							setImagePath(value);
						}}
					/>
				);
			},
		},
	];

	return (
		<>
			<Blacked
				onClick={() => {
					getBoadListMutate();
					setIsSelect(false);
				}}
			/>
			{IsMobile ? (
				<ModalWrapper IsMobile={IsMobile}>
					<ModalHeader>
						<Icon
							onClick={() => {
								getBoadListMutate();
								setIsSelect(false);
							}}
						>
							<FaChevronLeft />
						</Icon>
						<ModalTitle>요청 게시글</ModalTitle>
						<div></div>
					</ModalHeader>
					<ModalContent
						style={{
							border: "1px solid #d8d8d8",
							padding: 0,
							gap: 0,
							borderBottom: "none",
						}}
					>
						<BoardViewInput>
							<label htmlFor="name">요청시간</label>
							<div>{boardContent?.createdAt}</div>
						</BoardViewInput>

						<BoardViewInput>
							<label htmlFor="name">지사</label>
							<div>{boardContent?.branchName}</div>
						</BoardViewInput>

						<BoardViewInput>
							<label htmlFor="name">플랫폼</label>
							<div>{boardContent?.platformName}</div>
						</BoardViewInput>

						<BoardViewInput>
							<label htmlFor="name">이메일</label>
							<div>{boardContent?.email}</div>
						</BoardViewInput>

						<BoardViewInput>
							<label htmlFor="name">처리</label>
							<Select
								onChange={(e) => {
									setStatus(e);
									setChangeCheckStatus(true);
								}}
								options={[
									{ label: "처리중", value: 0 },
									{ label: "보류", value: 1 },
									{ label: "완료", value: 2 },
								]}
								style={{ width: 200 }}
								value={status}
							/>
							{changeCheckStatus && (
								<Button
									type="primary"
									style={{ marginLeft: 10 }}
									onClick={() => {
										const formData = new FormData();

										formData.append(
											"datas",
											JSON.stringify({
												status: status,
											})
										);

										API.postImage(
											"PUT",
											"/board/request/" + boardId,
											token + "",
											formData
										)
											.then((res: any) => {
												if (
													res.result
														.success
												) {
													message.success(
														"변경되었습니다"
													);
													getBoadListMutate();
												}
											})
											.catch((err: any) => {});
									}}
								>
									변경
								</Button>
							)}
						</BoardViewInput>
						<BoardViewInput>
							<label htmlFor="name">작성자</label>
							<div>{boardContent?.writer}</div>
						</BoardViewInput>

						{boardContent?.answeredAt !== null && (
							<BoardViewInput>
								<label htmlFor="name">응답시간</label>
								<div>{boardContent?.answeredAt}</div>
							</BoardViewInput>
						)}

						<BoardViewInput>
							<label style={{ padding: "90px 10px" }}>요청사항</label>
							<div
								style={{
									height: 200,
									overflowY: "auto",
									whiteSpace: "pre-wrap",
								}}
							>
								{boardContent?.content}
							</div>
						</BoardViewInput>
						<BoardViewInput>
							<label style={{ padding: "90px 10px" }}>이미지</label>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: 5,
									cursor: "pointer",
								}}
							>
								{boardContent?.imageList?.map((item, index) => (
									<div
										style={{ cursor: "pointer" }}
										onClick={() => {
											setImagePath(item.image);
										}}
									>
										<img
											src={
												process.env
													.REACT_APP_API_URL +
												item.image
											}
											alt={`boardContent_Image${index}`}
											width={60}
											height={60}
										/>
									</div>
								))}
							</div>
							{/*<p style={{ height: 200, overflowY: 'auto' }}>{boardContent?.content}</p>*/}
						</BoardViewInput>
					</ModalContent>

					{/* 메모입력 */}
					<DBModalInputLine style={{ marginTop: 10, flexDirection: "column", gap: 10 }}>
						<Table
							dataSource={boardComment}
							columns={mobileColumns}
							pagination={false}
						/>
						<DBModalMemoArea>
							<TextArea
								onChange={(e) => setAnswer(e.target.value)}
								placeholder="답변 입력"
								value={answer}
								style={{ width: "100%", height: 50, resize: "none" }}
							/>
							<MemoSubmitBtn onClick={addAnswer}>등록</MemoSubmitBtn>
						</DBModalMemoArea>
					</DBModalInputLine>

					<ModalInput
						style={{
							width: "100%",
							justifyContent: "center",
							alignItems: "start",
							marginTop: 20,
						}}
					>
						<Upload
							onChange={(fileList: any) => {
								setImages(fileList);
							}}
						>
							파일선택
						</Upload>
					</ModalInput>
				</ModalWrapper>
			) : (
				<ModalWrapper>
					<ModalHeader>
						<Icon
							onClick={() => {
								getBoadListMutate();
								setIsSelect(false);
							}}
						>
							<FaChevronLeft />
						</Icon>
						<ModalTitle>요청 게시글</ModalTitle>
						<div></div>
					</ModalHeader>
					<ModalContent
						style={{
							border: "1px solid #d8d8d8",
							padding: 0,
							gap: 0,
							borderBottom: "none",
						}}
					>
						<BoardViewInput>
							<label htmlFor="name">요청시간</label>
							<p>{boardContent?.createdAt}</p>
							<label htmlFor="name">지사</label>
							<p>{boardContent?.branchName}</p>
						</BoardViewInput>
						<BoardViewInput>
							<label htmlFor="name">플랫폼</label>
							<p>{boardContent?.platformName}</p>
							<label htmlFor="name">이메일</label>
							<p>{boardContent?.email}</p>
						</BoardViewInput>
						<BoardViewInput>
							<label htmlFor="name">처리</label>
							<Select
								onChange={(e) => {
									setStatus(e);
									setChangeCheckStatus(true);
								}}
								options={[
									{ label: "처리중", value: 0 },
									{ label: "보류", value: 1 },
									{ label: "완료", value: 2 },
								]}
								style={{ width: 200 }}
								value={status}
							/>
							{changeCheckStatus && (
								<Button
									type="primary"
									style={{ marginLeft: 10 }}
									onClick={() => {
										const formData = new FormData();

										formData.append(
											"datas",
											JSON.stringify({
												status: status,
											})
										);

										API.postImage(
											"PUT",
											"/board/request/" + boardId,
											token + "",
											formData
										)
											.then((res: any) => {
												if (
													res.result
														.success
												) {
													message.success(
														"변경되었습니다"
													);
													getBoadListMutate();
												}
											})
											.catch((err: any) => {});
									}}
								>
									변경
								</Button>
							)}
						</BoardViewInput>
						<BoardViewInput>
							<label htmlFor="name">작성자</label>
							<p>{boardContent?.writer}</p>
							{boardContent?.answeredAt !== null && (
								<>
									<label htmlFor="name">응답시간</label>
									<p>{boardContent?.answeredAt}</p>
								</>
							)}
						</BoardViewInput>
						<BoardViewInput>
							<label style={{ padding: "90px 10px" }}>요청사항</label>
							<p
								style={{
									height: 200,
									overflowY: "auto",
									whiteSpace: "pre-wrap",
								}}
							>
								{boardContent?.content}
							</p>
						</BoardViewInput>
						<BoardViewInput>
							<label style={{ padding: "90px 10px" }}>이미지</label>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: 5,
									cursor: "pointer",
								}}
							>
								{boardContent?.imageList?.map((item, index) => (
									<div
										style={{ cursor: "pointer" }}
										onClick={() => {
											setImagePath(item.image);
										}}
									>
										<img
											src={
												process.env
													.REACT_APP_API_URL +
												item.image
											}
											alt={`boardContent_Image${index}`}
											width={60}
											height={60}
										/>
									</div>
								))}
							</div>
							{/*<p style={{ height: 200, overflowY: 'auto' }}>{boardContent?.content}</p>*/}
						</BoardViewInput>
					</ModalContent>

					{/* 메모입력 */}
					<DBModalInputLine style={{ marginTop: 10, flexDirection: "column", gap: 10 }}>
						<Table dataSource={boardComment} columns={columns} pagination={false} />
						<DBModalMemoArea>
							<TextArea
								onChange={(e) => setAnswer(e.target.value)}
								placeholder="답변 입력"
								value={answer}
								style={{ width: "100%", height: 50, resize: "none" }}
							/>
							<MemoSubmitBtn onClick={addAnswer}>등록</MemoSubmitBtn>
						</DBModalMemoArea>
						<ModalInput
							style={{
								width: "100%",
								justifyContent: "center",
								alignItems: "start",
							}}
						>
							<Upload
								onChange={(fileList: any) => {
									setImages(fileList);
								}}
							>
								파일선택
							</Upload>
						</ModalInput>
					</DBModalInputLine>
				</ModalWrapper>
			)}

			{imagePath !== null && <ImageModal imagePath={imagePath} setImagePath={setImagePath} />}
		</>
	);
};

export default React.memo(BoardView);
